module.exports = __webpack_public_path__ + "9f9e15e08e3604e7c4df35f8c3cf8465.svg";